import { useState } from 'react';
import { Aviso, Boton, Campo } from '../comun/componentes';
import { useAccion } from '../comun/useDatos';
import { useSesion } from '../sesion/Sesion';

/**
 * Ingreso. Una sola acción, sin distracciones: en el mostrador se abre a las siete de la
 * mañana con una mano, mientras se prende la luz del consultorio con la otra.
 */
export function Ingreso() {
  const { ingresar } = useSesion();
  const { correr, ejecutando, error } = useAccion();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');

  return (
    <main className="grid min-h-dvh place-items-center bg-marca-800 px-4 py-10">
      <div className="w-full max-w-sm">
        <div className="mb-6 flex items-center gap-3 text-papel-50">
          <span
            aria-hidden="true"
            className="grid h-11 w-11 place-items-center rounded-xl bg-papel-50 text-lg font-bold text-marca-700"
          >
            DC
          </span>
          <div>
            <p className="text-lg font-semibold tracking-tight">AdvanceOdonto</p>
            <p className="text-dato text-marca-200">Gestión odontológica</p>
          </div>
        </div>

        <form
          className="panel space-y-4 p-5"
          onSubmit={async (evento) => {
            evento.preventDefault();
            await correr(() => ingresar(email.trim(), password));
          }}
        >
          <div>
            <h1 className="text-lg font-semibold text-tinta-900">Ingresá a tu clínica</h1>
            <p className="mt-1 text-dato text-tinta-500">
              Con el correo y la contraseña que te dio la administración.
            </p>
          </div>

          <Campo
            etiqueta="Correo"
            type="email"
            name="email"
            autoComplete="username"
            required
            autoFocus
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />

          <Campo
            etiqueta="Contraseña"
            type="password"
            name="password"
            autoComplete="current-password"
            required
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />

          {error && (
            <Aviso tono="alerta">{error}</Aviso>
          )}

          <Boton type="submit" variante="primario" ancho cargando={ejecutando}>
            Entrar
          </Boton>
        </form>

        <p className="mt-4 text-center text-dato text-marca-200">
          ¿Olvidaste la contraseña? Pedile a la administración de tu clínica que la reinicie.
        </p>
      </div>
    </main>
  );
}
